export function toBase64(file: File): Promise<FileReader['result']> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => {
      if (reader.error) {
        reject(reader.error);
        return;
      }
      reject(new Error('Unknown error'));
    };
  });
}

export async function fileToBase64Content(file: File): Promise<string> {
  const result = await toBase64(file);
  if (typeof result === 'string') {
    const parts = result.split(',');
    return parts[1] ?? '';
  }
  return '';
}

export default function b64EncodeUnicode(str: string): string {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
    return String.fromCharCode(parseInt(p1, 16));
  }));
}
